// Enhanced Scripts for Trump Was Right Website

// Direct event handler for mobile toggle (for debugging)
window.toggleMobileMenu = function() {
    console.log('Manual toggle function called');
    const mainNav = document.getElementById('main-nav');
    const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
    const body = document.body;
    
    if (mainNav && mobileMenuToggle) {
        mainNav.classList.toggle('active');
        mobileMenuToggle.classList.toggle('active');
        body.classList.toggle('menu-open');
    } else {
        console.error('Elements not found:', {mainNav, mobileMenuToggle});
    }
};

document.addEventListener('DOMContentLoaded', function() {
    // Mobile Navigation Toggle
    const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
    const mainNav = document.getElementById('main-nav');
    const body = document.body;
    
    if (mobileMenuToggle && !mobileMenuToggle.dataset.navBound) {
        mobileMenuToggle.dataset.navBound = '1'; // guard: some pages include this script twice and double-toggle cancels the menu
        mobileMenuToggle.addEventListener('click', function(e) {
            e.preventDefault(); // Prevent any default action
            e.stopPropagation(); // Stop event propagation
            
            console.log('Mobile menu toggle clicked'); // Debug message
            
            // Toggle classes
            mainNav.classList.toggle('active');
            this.classList.toggle('active');
            body.classList.toggle('menu-open');
            
            return false; // Extra safeguard
        });
    }
    
    // Smooth scrolling for anchor links
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function(e) {
            if (this.getAttribute('href') !== '#') {
                e.preventDefault();
                
                const targetId = this.getAttribute('href').substring(1);
                
                if (targetId) {
                    const targetElement = document.getElementById(targetId);
                    
                    if (targetElement) {
                        // Close mobile menu if open
                        if (mainNav.classList.contains('active')) {
                            mainNav.classList.remove('active');
                            mobileMenuToggle.classList.remove('active');
                            body.classList.remove('menu-open');
                        }
                        
                        // Smooth scroll to target
                        window.scrollTo({
                            top: targetElement.offsetTop - 80,
                            behavior: 'smooth'
                        });
                    }
                }
            }
        });
    });
    
    // Counter animation
    animateCounter('correct-counter', 42, 2000);
    
    // Update animation for article cards
    const elementsToAnimate = document.querySelectorAll('.category-card, .section-header');
    const articleCards = document.querySelectorAll('.article-card');
    
    // Ensure article cards are visible by default
    articleCards.forEach(card => {
        card.style.opacity = '1';
        card.style.visibility = 'visible';
        card.style.transform = 'none';
    });
    
    // Intersection Observer for scroll animations
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('animate');
                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.1
    });
    
    elementsToAnimate.forEach(element => {
        observer.observe(element);
    });
    
    // Set active navigation based on current page URL
    setActiveNavItem();

    // Also use scroll-based highlight for sections within the page
    highlightNavOnScroll();
    
    // Add current year to copyright
    document.querySelectorAll('.current-year').forEach(element => {
        element.textContent = new Date().getFullYear();
    });

    // Video Placeholders
    const videoPlaceholders = document.querySelectorAll('.video-placeholder');
    
    videoPlaceholders.forEach(placeholder => {
        placeholder.addEventListener('click', function() {
            const videoId = this.getAttribute('data-video-id');
            const container = this.closest('.responsive-video-container');
            
            if (videoId && container) {
                container.innerHTML = `<iframe src="https://www.youtube.com/embed/${videoId}?autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
                container.classList.add('video-active');
            }
        });
    });

    // Add quote symbols to major quotes (workaround for CSS pseudo-element issues)
    document.querySelectorAll('.major-quote').forEach(quote => {
        // Create a quote symbol element
        const quoteSymbol = document.createElement('span');
        quoteSymbol.className = 'quote-symbol';
        quoteSymbol.textContent = '"';
        quoteSymbol.style.position = 'absolute';
        quoteSymbol.style.top = '-30px';
        quoteSymbol.style.left = '20px';
        quoteSymbol.style.fontSize = '8rem';
        quoteSymbol.style.color = 'rgba(185, 43, 39, 0.1)';
        quoteSymbol.style.fontFamily = 'serif';
        quoteSymbol.style.lineHeight = '1';
        quoteSymbol.style.pointerEvents = 'none';
        
        // Add the quote symbol to the quote element
        quote.style.position = 'relative';
        quote.prepend(quoteSymbol);
    });

    // Update all submission sections
    updateSubmissionSections();
});

// Set active navigation item based on current page URL
function setActiveNavItem() {
    // Get current page path (like '/about.html' or '/index.html')
    const currentPath = window.location.pathname;
    const page = currentPath.split('/').pop() || 'index.html';
    
    // Remove '.html' to get the page name
    const pageName = page.replace('.html', '');
    
    // Clear all active states first
    document.querySelectorAll('#main-nav ul li a').forEach(link => {
        link.classList.remove('active');
    });
    
    // Find and set the active navigation item
    document.querySelectorAll('#main-nav ul li a').forEach(link => {
        const href = link.getAttribute('href');
        
        // Skip anchor links
        if (href && href.startsWith('#')) return;
        
        // Check if this link points to the current page
        if ((href === page) || 
            (href === pageName + '.html') || 
            (page === 'index.html' && href === './') || 
            (page === 'index.html' && href === '')) {
            link.classList.add('active');
        }
        
        // Special case for index.html and "home" links
        if (pageName === 'index' && (href === 'index.html' || href === './' || href === '')) {
            link.classList.add('active');
        }
    });
}

// Counter animation function
function animateCounter(id, target, duration) {
    const element = document.getElementById(id);
    if (!element) return;
    
    let start = 0;
    const increment = Math.ceil(target / 100); // Increment by 1% of the target
    const startTime = performance.now();
    
    function updateCounter(currentTime) {
        const elapsedTime = currentTime - startTime;
        const progress = Math.min(elapsedTime / duration, 1);
        
        // Easing function for smooth counter animation
        const easedProgress = easeOutQuad(progress);
        const value = Math.floor(easedProgress * target);
        
        if (value !== start) {
            element.textContent = value;
            start = value;
        }
        
        if (progress < 1) {
            requestAnimationFrame(updateCounter);
        } else {
            element.textContent = target;
        }
    }
    
    requestAnimationFrame(updateCounter);
}

// Easing function for smoother animations
function easeOutQuad(x) {
    return 1 - (1 - x) * (1 - x);
}

// Highlight navigation based on scroll position
function highlightNavOnScroll() {
    const sections = document.querySelectorAll('section[id]');
    
    window.addEventListener('scroll', () => {
        let current = '';
        const scrollPosition = window.scrollY + 100; // Offset for header
        
        sections.forEach(section => {
            const sectionTop = section.offsetTop;
            const sectionHeight = section.offsetHeight;
            
            if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
                current = section.getAttribute('id');
            }
        });
        
        // Only update section-based navigation (anchor links)
        document.querySelectorAll('#main-nav ul li a[href^="#"]').forEach(link => {
            const href = link.getAttribute('href');
            
            if (href && href.substring(1) === current) {
                link.classList.add('active');
            } else if (href && href.startsWith('#')) {
                link.classList.remove('active');
            }
        });
    });
}

// Add styles for the mobile menu toggle animation
document.head.insertAdjacentHTML('beforeend', `
<style>
    .mobile-menu-toggle.active span:nth-child(1) {
        transform: translateY(8px) rotate(45deg);
    }
    
    .mobile-menu-toggle.active span:nth-child(2) {
        opacity: 0;
    }
    
    .mobile-menu-toggle.active span:nth-child(3) {
        transform: translateY(-8px) rotate(-45deg);
    }
    
    .menu-open {
        overflow: hidden;
    }
    
    .article-card, .category-card, .section-header {
        opacity: 0;
        transform: translateY(30px);
        transition: opacity 0.6s ease, transform 0.6s ease;
    }
    
    .article-card.animate, .category-card.animate, .section-header.animate {
        opacity: 1;
        transform: translateY(0);
    }
    
    .article-card:nth-child(2) { transition-delay: 0.1s; }
    .article-card:nth-child(3) { transition-delay: 0.2s; }
    .article-card:nth-child(4) { transition-delay: 0.3s; }
    .article-card:nth-child(5) { transition-delay: 0.4s; }
    
    .category-card:nth-child(2) { transition-delay: 0.1s; }
    .category-card:nth-child(3) { transition-delay: 0.2s; }
    .category-card:nth-child(4) { transition-delay: 0.3s; }
</style>
`);

// Function to update submission sections to have dual desktop/mobile structure
function updateSubmissionSections() {
    // Find all submission sections that don't already have the dual structure
    const submissionSections = document.querySelectorAll('.submission-section');
    
    submissionSections.forEach(section => {
        // Skip if this section already has the dual structure
        if (section.querySelector('.desktop-submission-version') || 
            section.querySelector('.mobile-submission-version')) {
            return;
        }
        
        // Get the original HTML
        const originalHTML = section.innerHTML;
        
        // Create new HTML with dual structure
        const newHTML = `
            <!-- DESKTOP VERSION (hidden on mobile) -->
            <div class="desktop-submission-version">
                ${originalHTML}
            </div>

            <!-- MOBILE VERSION (hidden on desktop) -->
            <div class="mobile-submission-version">
                <div class="container">
                    <div style="text-align: center; background: transparent; margin: 0;">
                        <!-- Image First -->
                        <div style="width: 100%; height: 180px; overflow: hidden; margin: 0 0 1.5rem 0; line-height: 0;">
                            <img src="${section.querySelector('.submission-image img').src}" 
                                 alt="${section.querySelector('.submission-image img').alt}" 
                                 style="width: 100%; height: 100%; object-fit: cover; display: block; object-position: center -20%;">
                        </div>
                        
                        <!-- Content Second -->
                        <div style="padding: 0 1rem; margin: 0;">
                            <h2 style="font-size: 1.3rem; text-transform: uppercase; margin-bottom: 0.75rem; line-height: 1.3; word-break: break-word; color: #002856;">
                                ${section.querySelector('.submission-content h2').textContent}
                            </h2>
                            <p style="font-size: 0.9rem; line-height: 1.4; margin-bottom: 1.5rem; color: #444;">
                                ${section.querySelector('.submission-content p').textContent}
                            </p>
                            <div style="margin-bottom: 1.5rem;">
                                <a href="${section.querySelector('.submission-content a').href}" class="btn primary-btn">
                                    ${section.querySelector('.submission-content a').innerHTML}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
        
        // Replace the original content
        section.innerHTML = newHTML;
    });
}